import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-xs sm:text-sm text-gray-400 font-medium mt-6" data-id="element-280">
      <div className="flex items-center gap-1.5" data-id="element-281">
        <ShieldCheckIcon className="w-4 h-4 text-padel-lime" data-id="element-282" />
        <span data-id="element-283">Garantía 7 días</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-284">
        <LockIcon className="w-4 h-4 text-padel-lime" data-id="element-285" />
        <span data-id="element-286">Pago seguro</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-287">
        <ZapIcon className="w-4 h-4 text-padel-lime" data-id="element-288" />
        <span data-id="element-289">Acceso en 5 minutos</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-290">
        <CreditCardIcon className="w-4 h-4 text-padel-lime" data-id="element-291" />
        <span data-id="element-292">Mercado Pago — Tarjeta — Transferencia</span>
      </div>
    </div>;
}